export default {
    person: {
        wzTZ: '王者榮耀後台管理系統通知公告',
        wzKF: '開發者聯繫方式',
        QQ1: 'QQ號1',
        QQ2: 'QQ號2',
        mailbox: '郵箱',
        browser: '瀏覽器',
        RecommendedUse: '推薦使用',
        mattersNeedingAttention: '注意事項',
        mattersNeedingAttention1: '禁止喺原有基礎上修改並用于商業用途',
        mattersNeedingAttention2: '此網頁對於開發者而言，僅用于交流與學習',
        version: '版本號',
    },
    home:{
        wzry:"登錄",
        game:'登錄',
        account:'請輸入賬號',
        password:'請輸入密碼',
        remember:'記住密碼'
    },
    Login:{
        name:"歡迎",
        register:"註冊",
        logon:"登錄",
        ZY:"秋色微涼黯傷",
        ReSelect:"重新選擇"
    }
};